import React from "react";
const Logo = () => {
    return (
        <div style={{fontWeight: '200', fontFamily: 'Bungee', color: '#CD2C51', letterSpacing: '2px' }}>
            66Movies.com
        </div>
    )
}

export default Logo;